import React from 'react';
import { useUserData } from '../hooks/useUserData';
import AdminDashboard from './AdminDashboard';
import ClinicianDashboard from './ClinicianDashboard';
import Login from './Login';

const Dashboard = () => {
  const { user, role, loading } = useUserData();

  if (loading) {
    return <div className="p-6 text-center text-gray-600">Loading dashboard...</div>;
  }

  if (!user) {
    return <Login />;
  }

  if (!role) {
    return <div className="p-6 text-center text-red-500">⚠️ No role assigned. Contact admin.</div>;
  }

  return (
    <div className="p-4">
      <div className="text-sm text-gray-500 mb-2">👤 Welcome, {user.email}</div>
      {role === 'admin' ? <AdminDashboard user={user} /> : <ClinicianDashboard user={user} />}
    </div>
  );
};

export default Dashboard;
